module.exports = {"school":{"云南楚雄金碧小学":[170,230],"云南大理拥翠小学":[145,298],"云南大理麻栗小学":[149,262],"云南大理鼠街小学":[138,254],"云南大理新平美丽小学":[118,250],"云南楚雄分众美丽小学":[136,230],"广西百色百省中学":[338,324],"广西百色五村小学":[370,320],"广西百色琴华小学":[364,304],"广西百色新立小学":[458,316],"广西百色宝美小学":[426,283],"广西百色市露美小学":[370,280],"广东汕头龟山小学":[628,327],"广东潮州夏校小学":[668,328]}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/map.json
// module id = 215
// module chunks = 0